<template>
  <v-row justify="center">
    <v-dialog v-model="active" persistent scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card :loading="loading">
          <v-progress-linear v-if="loading" indeterminate color="primary" rounded height="6"></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                {{ value === 0 ? "Nueva cola" : "Actualizar cola" }}
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre"
                        name="nombre"
                        prepend-inner-icon="mdi-account"
                        type="text"
                        color="blue-grey"
                        v-model="data.name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="cola" rules="required" v-slot="{ errors }">
                      <v-autocomplete
                        :disabled="isLoadingQueueItems"
                        :items="queueItems"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Cola"
                        name="number"
                        prepend-inner-icon="mdi-numeric"
                        color="blue-grey"
                        v-model="data.number"
                        :error-messages="errors"
                      ></v-autocomplete>
                      <!-- <v-text-field
                                                required
                                                filled
                                                rounded
                                                class="rounded-small"
                                                dense
                                                label="Número"
                                                name="number"
                                                prepend-inner-icon="mdi-numeric"
                                                color="blue-grey"
                                                v-model="data.number"
                                                :error-messages="errors"
                                            ></v-text-field> -->
                    </ValidationProvider>
                  </v-col>

                  <!-- Tipo -->
                  <v-col cols="12" class="py-0">
                    <ValidationProvider name="WhatsApp" rules="required" v-slot="{ errors }">
                      <v-radio-group v-model="data.whatsapp" :error-messages="errors" row>
                        <template v-slot:label>
                          WhatsApp
                        </template>
                        <v-radio label="Sí" :value="1"></v-radio>
                        <v-radio label="No" :value="0"></v-radio>
                      </v-radio-group>
                    </ValidationProvider>
                  </v-col>

                  <!-- Activo -->
                  <v-col cols="12" class="py-0">
                    <ValidationProvider name="Activo" rules="required" v-slot="{ errors }">
                      <v-radio-group v-model="data.status" :error-messages="errors" row>
                        <template v-slot:label>
                          Activo
                        </template>
                        <v-radio label="Sí" value="active"></v-radio>
                        <v-radio label="No" value="inactive"></v-radio>
                      </v-radio-group>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="$emit('dialog:change', 'cerrar')"
                >Cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                dark
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="
                  () => {
                    value === 0 ? passes(register) : passes(update);
                  }
                "
              >
                {{ value === 0 ? "Añadir" : "Actualizar" }}
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import vuescroll from "vuescroll";

export default {
  props: ["active", "data", "value"],

  components: {
    vuescroll,
  },

  data() {
    return {
      search: "",
      dialog: false,
      loading: false,
      isLoadingQueueItems: false,
      queueItems: [],
    };
  },

  created() {
    this.getQueues();
  },

  methods: {
    resetform() {
      this.$refs.obs.reset();
    },

    async register() {
      try {
        this.loading = true;
        const enviar = {
          name: this.data.name,
          number: parseInt(this.data.number),
          whatsapp: this.data.whatsapp,
          status: this.data.status,
        };
        const response = await this.$store.dispatch("queue/REGISTER_QUEUE", enviar);
        this.$snotify.success("Cola creada con éxito.", "¡Hecho!");
        this.loading = false;
        this.resetform();
        let message = response.data.message;
        this.$emit("dialog:change", message);
      } catch (error) {
        this.$snotify.error("No se pudo crear la cola.", "¡Error!");
        // console.error(error);
      }
    },

    async update() {
      try {
        this.loading = true;
        const enviar = {
          data: {
            name: this.data.name,
            number: parseInt(this.data.number),
            whatsapp: this.data.whatsapp,
            status: this.data.status,
          },
          id: this.data.id,
        };
        const response = await this.$store.dispatch("queue/EDIT_QUEUE", enviar);
        // this.$snotify.success("Cola actualizada con éxito.", "¡Hecho!");
        this.loading = false;
        this.resetform();
        let message = response.data.message;
        this.$emit("dialog:change", message);
      } catch (error) {
        this.$snotify.error("No se pudo actualizar la cola.", "¡Error!");
        // console.error(error);
      }
    },

    async getQueues() {
      this.isLoadingQueueItems = true;

      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/clients/listQueueCreate`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.queueItems = res.data;
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("No se pudo obtener listado de colas.", "¡Error!");
        })
        .finally(() => {
          this.isLoadingQueueItems = false;
        });
    },

    eventdialog() {
      this.activeAlert = false;
    },
  },
};
</script>
